import React from 'react';
import cx from 'classnames';
import { ReactSVG } from 'react-svg';
import chevron from '@/widget/ui/images/chevron-right.svg';
import styles from './QuickLinks.module.scss';

interface Props {
  links: {
    name: string;
    url: string;
  }[];
  host: string;
  color: string;
}

function QuickLinks({ links, host, color }: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.caption}>
          {window.ChatWidget.i18n.t('chat_widget.links')}
        </div>
      </div>
      <div className={cx(styles.bottom, styles.links)}>
        {links.map((link) => (
          <div className={styles.linkWrapper} key={link.url + link.name} onClick={() => window.open(link.url, '_blank')}>
            <div className={styles.link}>{link.name}</div>
            <div className={styles.chevron} style={{ color }}>
              <ReactSVG src={host + chevron} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QuickLinks;
